const locale = {
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmTitle: 'Confirmation',
    stay: 'Stay',
    leave: 'Leave',
    saveSuccess: 'The changes saved',
    generalError: 'Oops! Something went wrong! <br />Help us improve your experience by sending an ',
    errorTicket: "error ticket...",
    loading: 'Loading...',
    duplicateMsg: 'Input files with similar names are not allowed!',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    download: 'Download',
    fitToggle: 'Fit toggle',
    fullScreenToggle: 'Fullscreen toggle',
    mail: {
        title: 'New message',
        to: 'To',
        subject: 'Subject',
        message: 'Message',
        send: 'Send'
    }
};

export default locale;
